<style scoped>
.day_header {
	background-color: white;
	text-align: center;
	height: 50px;
}

.day_selected {
	background-color: #EEEEFF;
}

.day_content {
	padding: 5px;
}

</style>

<template>
	<div>
		<div :class="{ 'day_header': true, 'day_selected': is_selected_date }">
			<div>{{ day.text }}</div>
			<div class="caption">Total: {{ format_duration(total_timesheet_duration) }}</div>
		</div>
		<div class="day_content">
			<v-alert type="error" v-if="errormsg != ''">{{
				errormsg
			}}</v-alert>

			<v-timesheet-item
				v-for="timesheet in timesheets" 
				:key="timesheet.id"
				:timesheet="timesheet"
			/>

			<v-event-item
				v-for="event in filtered_events"
				:key="event.id"
				:event="event"
			/>

			<!--<div v-if="loading_timesheets">
				<v-skeleton-loader
					type="list-item-avatar-two-line"
					width="100%"
				/>
			</div>-->
		</div>
	</div>
</template>

<script>
import timesheet_item from "@/components/timesheets/timesheet_item"
import event_item from "@/components/events/event_item"

export default {
	components: {
		'v-timesheet-item': timesheet_item,
		'v-event-item': event_item
	},
	data() {
		return {
			errormsg: "",
			loading_timesheets: false,
			timesheets: [],
			total_timesheet_duration: 0,
			loading_events: false,
			events: [],
			total_event_duration: 0,
		}
	},
	props: {
		day: {
			type: Object,
			default: null
		},
		is_selected_date: {
			type: Boolean,
			default: false
		},
	},
	mounted() {
		this.load_timesheets();
		this.load_events();
	},
	computed: {
		user() {
			return this.$store.state.user
		},
		filtered_events() {
			let filtered = [];

			this.events.forEach(event => {
				// TODO possibly add flags here
				if (event.type == 1) {
					// include tentative
					filtered.push(event);
				} else if (event.type == 2) {
					// include busy
					filtered.push(event);
				} else if (event.type == 3) {
					// exclude completed
					// filtered.push(event);
				} else if (event.type == 4) {
					// include leave
					filtered.push(event);
				} else if (event.type == 5) {
					// include public holidays
					filtered.push(event);
				}
			});

			// TODO sort this?

			return filtered;
		}
	},
	methods: {
		load_timesheets() {
			let user = this.user

			if (user == null) {
				// not yet available, still loading...
				// console.log("User not yet available...");
				return;
			} else if (user.addressbook == null) {
				this.errormsg = "Your user account is not linked to an employee record...";
				return;				
			}

			let self = this;
			this.timesheets = [];
			this.loading_timesheets = true;
			this.errormsg = "";
			this.total_timesheet_duration = 0;

			// build our url parameters
			let params = new Array();
			params.push("employees=" + user.addressbook.id);
			params.push("start_date=" + this.day.value);
			params.push("end_date=" + this.day.value);

			// build our url, we have to add url escaping here!
			let url = "/api/timesheets";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log("got data");

						self.timesheets = json.data;

						self.timesheets.forEach(function(timesheet) {
							self.total_timesheet_duration += timesheet.duration;
						})
					} else {
						self.errormsg = json.reason;
					}					
				})
				.catch(function(e) {
					// this is the error for the last search we've started, lets show it.
					self.errormsg = e.message;
					console.log(e);
				})
				.finally(function() {
					self.loading_timesheets = false
				})
		},
		load_events() {
			let user = this.user

			if (user == null) {
				// not yet available, still loading...
				// console.log("User not yet available...");
				return;
			} else if (user.addressbook == null) {
				this.errormsg = "Your user account is not linked to an employee record...";
				return;				
			}

			let self = this;
			this.timesheets = [];
			this.loading_events = true;
			this.errormsg = "";
			this.total_event_duration = 0;

			// build our url parameters
			let params = new Array();
			params.push("employees=" + user.addressbook.id);
			params.push("start_date=" + this.day.value);
			params.push("end_date=" + this.day.value);

			// build our url, we have to add url escaping here!
			let url = "/api/events";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log("got data");

						self.events = json.data;

						self.events.forEach(function(event) {
							// !BAS! I'm keeping this total but we're not currently using this.
							// As discussed with DiB we just want to show total recorded time so users can quickly see how much they have left to record.
							if (event.type == 2) {
								// only add busy events
								self.total_event_duration += event.duration;
							}

							// TODO also sum leave (include public) so we can subtract it from our expected time
						})
					} else {
						self.errormsg = json.reason;
					}					
				})
				.catch(function(e) {
					// this is the error for the last search we've started, lets show it.
					self.errormsg = e.message;
					console.log(e);
				})
				.finally(function() {
					self.loading_events = false
				})
		},
		format_duration(minutes) {
			if (minutes == 0) {
				return '0h';
			}

			let hours = Math.floor(minutes / 60.0);
			let mins = minutes - (hours * 60.0);

			let fmt = '';
			if (hours > 0) {
				fmt += hours + 'h';
				if (mins > 0) {
					fmt += ' ';
				}
			}

			if (mins > 0) {
				fmt += mins + 'm';
			}

			return fmt;
		}
	},
	watch: {
		'day.value': function() {
			this.load_timesheets();
			this.load_events();
		},
		'user.id': function() {
			this.load_timesheets();
			this.load_events();
		}
	}
}
</script>